import { Box, Switch, Typography } from '@mui/material';
import { useState } from 'react';

type BooleanFieldProps = {
    trueLabel?: string;
    falseLabel?: string;
    defaultChecked: boolean;
    onChange: (checked: boolean) => void;
};

const AppCriteriaTypeBool = ({ defaultChecked, onChange, falseLabel = 'No', trueLabel = 'Yes' }: BooleanFieldProps) => {
    const [ checked, setChecked ] = useState(defaultChecked);

    return (
        <Box
            sx={{
                border: '1px solid #ddd',
                borderRadius: 3,
                px: 2,
                py: 1.5,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                backgroundColor: '#fff',
            }}
        >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Typography variant="body2">
                    {checked ? trueLabel : falseLabel}
                </Typography>

                <Switch
                    checked={checked}
                    onChange={(e) => {
                        setChecked(e.target.checked);
                        onChange(e.target.checked);
                    }}
                />
            </Box>
        </Box>
    );
};

export default AppCriteriaTypeBool;
